import { render, staticRenderFns } from "./ProjectTypeEdit.vue?vue&type=template&id=696c0d4b"
import script from "./ProjectTypeEdit.vue?vue&type=script&lang=js"
export * from "./ProjectTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports